import { LinkType } from "./enums";
import { LinkEntry, LinkObject, LinksObject } from "./interfaces";
import { getV2ArticlePath, getV2RessortPath } from "./url";

export function getExternalLink(teaser: LinksObject) : string {
  return teaser?.links?.find((x: LinkEntry) => x.rel === LinkType.External || x.rel === LinkType.NoFollow )?.href ?? ""
}

export function getEnclosureLink(teaser: LinksObject) : string {
  return teaser?.links?.find((x: LinkEntry) => x.rel === LinkType.Enclosure)?.href ?? ""
}

export function getLinkObjectFromTeaserV2(teaser: LinksObject) : LinkObject {
  if(teaser && teaser.links) {
    const parts = getSpecificLink(teaser.links, LinkType.Self).split("/");
    if(parts.length > 3) {
      const type = parts[parts.length-2]
      const id = parts[parts.length-1]
      if(type == "detail") {
        return { articleId: id, internalLink: getV2ArticlePath(id)}
      }
      if(type == "ressort") {
        return { ressortId: id, internalLink: getV2RessortPath(id)}
      }
    }
    else {
      const link = getExternalLink(teaser);
      if(link) {
        return { externalLink: link};
      }
    }
  }

  return {}
}


export function getLinkObjectFromModuleV2(module) : LinkObject {
  const moduleLink = module.links?.[0];
  if(moduleLink && moduleLink.type == LinkType.LinkResource) {
    const link = getSpecificLink(moduleLink.url, LinkType.WebView);
    if(link) {
      return { externalLink: link};
    }
  }
  else if(moduleLink?.links) {
    return getLinkObjectFromTeaserV2(moduleLink);
  }

  return {}
}

export function getLinkObjectFromTeaser(teaser: LinksObject) : LinkObject {
  if(teaser && teaser.links) {
    const parts = getSpecificLink(teaser.links, LinkType.Self).split("/");
    if(parts.length > 3) {
      const type = parts[parts.length-2]
      const id = parts[parts.length-1]
      if(type == "detail") {
        return { articleId: id, internalLink: `/article/${id}`}
      }
      if(type == "ressort") {
        return { ressortId: id, internalLink: `/ressort/${id}`}
      }
    }
    else {
      const link = getExternalLink(teaser);
      if(link) {
        return { externalLink: link};
      }
    }
  }

  return {}
}

export function getLinkObjectFromModule(module) : LinkObject {
  const moduleLink = module.links?.[0];
  if(moduleLink && moduleLink.type == LinkType.LinkResource) {
    const link = getSpecificLink(moduleLink.url, LinkType.WebView);
    if(link) {
      return { externalLink: link};
    }
  }
  else if(moduleLink?.links) {
    return getLinkObjectFromTeaser(moduleLink);
  }

  return {}
}

export function getSpecificLink(links, linkType) {
  let link = "";
  if (links) {
    links.forEach((element) => {
      if (element.rel === linkType) link = element.href;
      if (element.identifier == linkType) link = element.url;
    });
  }
  return link;
}

export function getSpecificLinks(links, linkType) {
  let foundLinks: string[] = [];
  if (links) {
    links.forEach((element) => {
      if (element.rel === linkType) foundLinks.push(element.href);
      if (element.identifier == linkType) foundLinks.push(element.url);
    });
  }
  return foundLinks;
}

export function getExternalLinks(teaser) : string[] {
  let externalLinks: string[] = [];
  if(teaser?.links) {
    teaser.links.forEach((element) => {
      if (element.rel === LinkType.External || element.rel === LinkType.NoFollow) externalLinks.push(element.href);
      if (element.identifier == LinkType.External || element.identifier == LinkType.NoFollow) externalLinks.push(element.url);
    });
  }
  return externalLinks;
}

export function getV2MerklistePath() : string {
  return "/v2/merkliste"
}